<template>
    <div class="bg-blue-100 text-blue-500 p-4 border border-blue-500">
        <div class="flex flex-row items-start justify-between">
            <div class="flex flex-row items-center justify-start">
                <icon-info class="mr-2"></icon-info>
                <div class="font-bold">{{ title }}</div>
            </div>
            <div v-if="hideable" @click="$emit('hide')" class="font-bold text-sm cursor-pointer select-none">x</div>
        </div>
        <div class="mt-2">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import IconInfo from '@/components/icons/Info'

export default {
    components: { IconInfo },
    props: {
        title: String,
        hideable: {
            type: Boolean,
            default: false
        },
        simple: {
            type: Boolean,
            default: false
        }
    }
}
</script>